import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
Vue.config.productionTip = false

router.beforeEach((to, _, next) => {
  store.state.company = to.params.company || ''
  const menuPrincipalHidden = to.name.toLowerCase().includes('print')
  store.commit('setMenuPrincipalHidden', menuPrincipalHidden)
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js